/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Col_LinkedInputs */

const cs_documents_col_linked = /** @type {(inputs: Documents_Col_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propojeno s`)
};

const en_documents_col_linked = /** @type {(inputs: Documents_Col_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linked to`)
};

/**
* | output |
* | --- |
* | "Linked to" |
*
* @param {Documents_Col_LinkedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_col_linked = /** @type {((inputs?: Documents_Col_LinkedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Col_LinkedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_col_linked(inputs)
	return cs_documents_col_linked(inputs)
});